/* Murmure — éditeur de stickers personnalisés.
 *
 * Ce fichier orchestre : le tarif, les options, les échanges avec l'app et le panier.
 * La composition elle-même — calques, sélection, manipulation, vectorisation des
 * textes — vit dans sticker-canevas.js, qui ne connaît ni prix ni panier.
 *
 * Le document produit par le canevas est la seule chose qui parte à l'impression. Le
 * navigateur n'exporte aucune image : il décrit, le serveur compose. Un 24 x 24 cm à
 * 300 dpi fait 2835 px de côté, et le fabriquer dans un canvas de téléphone échoue
 * une fois sur deux, sans le dire.
 */
(function () {
  "use strict";

  // --- Tarif ------------------------------------------------------------------
  // La grille vient du metafield sticker.pricing, réglé dans l'onglet Tarifs du Studio.
  // Ce bloc doit rendre EXACTEMENT le même prix que le Cart Transform, qui fait autorité
  // sur ce qui est facturé : un écart d'un centime, et le client voit un prix puis en
  // paie un autre. L'ordre des multiplications et l'arrondi sont donc figés, pas libres.

  /**
   * Arrondi au centime, moitié vers le haut — l'équivalent de ROUND_HALF_UP de Python.
   *
   * Math.round(x * 100) / 100 ne suffit pas : 1.005 * 100 vaut 100.49999999999999 en
   * binaire et redescendrait à 1,00. On passe donc par la représentation décimale la
   * plus courte du nombre, celle que rendent String() en JS et repr() en Python, puis
   * on arrondit sur les chiffres eux-mêmes.
   */
  function arrondi2(x) {
    if (!isFinite(x)) return 0;
    var s = String(x);
    // Notation exponentielle : hors du domaine des prix, on ne s'y attarde pas.
    if (s.indexOf("e") >= 0 || s.indexOf("E") >= 0) return Math.round(x * 100) / 100;
    var neg = s.charAt(0) === "-";
    if (neg) s = s.slice(1);
    var pt = s.indexOf(".");
    var ent = pt < 0 ? s : s.slice(0, pt);
    var dec = pt < 0 ? "" : s.slice(pt + 1);
    while (dec.length < 3) dec += "0";
    var cents = parseInt(ent, 10) * 100 + parseInt(dec.slice(0, 2), 10);
    if (dec.charAt(2) >= "5") cents += 1;
    return (neg ? -cents : cents) / 100;
  }

  /** Prix unitaire TTC. Retourne 0 si la combinaison n'existe pas dans la grille. */
  function prixUnitaire(grille, choix) {
    if (!grille) return 0;
    var base = grille.base_ht[String(choix.qte)];
    var ct = grille.taille[String(choix.taille)];
    var cp = grille.papier[choix.papier];
    var cf = grille.forme[choix.forme];
    if (base == null || ct == null || cp == null || cf == null) return 0;
    var p = base * ct;
    p = p * cp;
    p = p * cf;
    if (choix.lamination) p = p * grille.lamination;
    return arrondi2(p * (1 + grille.tva));
  }

  /**
   * Total de la commande, en centimes.
   *
   * C'est l'unitaire déjà arrondi qui est multiplié, jamais le prix brut : sinon
   * l'addition dériverait de plusieurs centimes sur 1500 exemplaires et le panier
   * ne retomberait pas sur ce qu'annonce l'éditeur.
   */
  function totalCentimes(grille, choix) {
    return Math.round(prixUnitaire(grille, choix) * 100) * choix.qte;
  }

  // Exposé avant tout travail sur le DOM : le contrôle de cohérence avec le modèle
  // Python attaque ces fonctions sans monter d'éditeur.
  window.MURMURE_STICKER = {
    arrondi2: arrondi2,
    prixUnitaire: prixUnitaire,
    totalCentimes: totalCentimes
  };

  var root = document.querySelector("[data-sticker-editor]");
  if (!root) return;

  // --- Contexte ---------------------------------------------------------------
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var money = function (cents) {
    return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  };
  var T = function (cle, repli) {
    var v = root.getAttribute("data-t-" + cle);
    return v == null || v === "" ? repli : v;
  };
  var lireJson = function (selecteur) {
    try {
      var n = $(selecteur);
      return n ? JSON.parse(n.textContent) : null;
    } catch (e) { return null; }
  };

  var grille = lireJson("[data-sticker-pricing]");
  if (!grille) {
    // Sans grille, tout prix affiché serait inventé. Mieux vaut une fiche muette
    // qu'une commande passée sur un tarif faux.
    console.warn("Sticker : grille tarifaire absente ou illisible.");
    return;
  }
  var ASSETS = lireJson("[data-sticker-assets]") || { opentype: "", polices: {} };

  var API = String(root.getAttribute("data-endpoint") || "").replace(/\/+$/, "");
  var VARIANT = parseInt(root.getAttribute("data-variant-id"), 10) || 0;

  /**
   * Part du format occupée par le liseré blanc d'une découpe à la forme.
   *
   * ⛔ MÊME NOMBRE QUE `sticker-render.LISERE_RELATIF`, ET C'EST LUI QUI FAIT FOI. L'aperçu
   * qui montrerait un autre bord que celui découpé serait pire qu'aucun aperçu ;
   * `tests/sticker-matiere.test.js` relit la constante du serveur et refuse l'écart.
   *
   * ⛔ POURQUOI UNE PART ET NON DES MILLIMÈTRES. Un liseré fixe ne peut pas paraître le même
   * à tous les formats : 2 mm valent le vingtième d'un 4 cm et le centième d'un 24 cm. Le
   * client voyait donc son bord maigrir en changeant de taille et croyait sa commande
   * changée — reproche de Jonathan les 20/08/2026, deux fois. Une part constante règle la
   * question à la racine : changer de format ne change plus rien à l'écran.
   */
  var LISERE_RELATIF = 0.025;

  /**
   * Rayon des coins arrondis d'un rectangle, en part du PLUS PETIT côté du sticker.
   *
   * ⛔ MÊME NOMBRE QUE `sticker-render.RAYON_RELATIF`, ET C'EST LUI QUI FAIT FOI. L'aperçu qui
   * arrondirait plus que la lame promettrait une coupe qui n'existe pas ;
   * `tests/sticker-matiere.test.js` relit la constante du serveur et refuse l'écart.
   *
   * ⛔ UNE PART, ET NON DES MILLIMÈTRES, pour la même raison que le liseré : un rayon fixe
   * paraîtrait énorme sur un 4 cm et invisible sur un 24, si bien que changer de format
   * changerait l'allure du sticker — ce qu'on a retiré le 20/08/2026. Le petit côté parce qu'un
   * rayon plus grand que sa moitié n'est plus un coin arrondi mais une pastille.
   */
  var RAYON_RELATIF = 0.08;

  /**
   * Le liseré blanc d'une découpe à la forme, en centimètres.
   *
   * Il est COMPRIS dans l'encombrement commandé, il ne s'y ajoute pas : même règle que
   * sticker-render.js. Un 8 cm reste un 8 cm ; c'est le motif qui rétrécit pour lui faire
   * place. Sur une forme géométrique il n'y a pas de liseré : le bord du papier est le bord
   * de la forme.
   */
  function contourCm() {
    return etat.forme === "forme" ? LISERE_RELATIF * etat.taille : 0;
  }

  var COULEURS = ["#111111", "#FFFFFF", "#C2453A", "#E4A11B", "#2E7D5B", "#2F5FA8", "#7B4BA8", "#B5713F"];

  // --- État -------------------------------------------------------------------
  var etat = {
    forme: "forme",
    /*
     * Les coins du rectangle — « vifs » ou « arrondis ».
     *
     * ⚠️ CE N'EST PAS UNE DÉCOUPE, et il ne faut pas le glisser dans `forme`. Le prix ne
     * change pas, la grille tarifaire n'en sait rien, et le Cart Transform n'a rien à
     * recalculer : une cinquième découpe aurait demandé un coefficient de plus dans le
     * métachamp, donc une grille republiée, pour un tarif identique.
     */
    coins: "vifs",
    proportion: "1:1",
    taille: 8,
    papier: "blanc",
    lamination: false,
    qte: 50,
    /*
     * Le support de l'aperçu — « aucun », un capot de portable, une porte de frigo.
     *
     * ⚠️ IL NE PART PAS AU PANIER : c'est une façon de regarder, pas une option du produit.
     * Il commence à « aucun » pour que la fiche s'ouvre sur le dessin en grand : un 4 cm posé
     * d'office sur un frigo n'occuperait que le quinzième du plan, et le client ne pourrait
     * plus juger ce qu'il dessine — le reproche même auquel les supports répondent.
     */
    support: "aucun"
  };

  var sources = {};           // srcId -> { url, cut, largeur, hauteur }
  var enCours = false;        // un appel réseau bloque l'ajout au panier
  // Service déclaré hors service par /health : le bouton « détourer » d'un calque
  // image est alors désactivé. Les découpes, elles, restent toutes disponibles.
  var detourageEteint = false;
  var silhouetteCourante = null;  // boîte de l'encre, mesurée par le canevas
  var masqueCourant = null;       // silhouette de découpe, qui borne le papier à l'écran

  var canevas = window.MurmureCanevas.creer({
    scene: $("[data-cv-scene]"),
    urls: ASSETS,
    // Le zoom se rafraîchit à chaque changement, pas seulement au changement de
    // sélection : taper un texte recalcule sa largeur, et un chiffre resté sur
    // l'ancienne valeur ferait croire à un cran qui rétrécit.
    onChange: function () { planifierMesure(); majZoom(canevas && canevas.selection()); maj(); },
    // Le panneau ne suit plus la sélection mais le visuel : il n'y en a qu'un, et se
    // fier à la sélection refermait le retrait du fond au premier clic dans le vide.
    onSelect: function () { majPanneau(visuel()); },
    onHistorique: majHistorique
  });

  /**
   * Les deux flèches ne s'allument que si elles mènent quelque part.
   *
   * Le canevas retient le document vide dès sa construction, et prévient : l'appel
   * arrive donc avant que `canevas` ne soit affecté. Les boutons partent désactivés
   * dans le balisage, il n'y a rien à faire de ce premier signal.
   */
  function majHistorique() {
    if (!canevas) return;
    var a = $("[data-cv-histo='annuler']");
    var r = $("[data-cv-histo='refaire']");
    if (a) a.disabled = !canevas.peutAnnuler();
    if (r) r.disabled = !canevas.peutRefaire();
  }

  // --- Géométrie ----------------------------------------------------------------

  /** Rapport largeur/hauteur du sticker fini, à l'intérieur de l'encombrement carré. */
  function ratioCadre() {
    if (etat.forme === "rond" || etat.forme === "forme") return 1;
    if (etat.proportion === "4:3") return 4 / 3;
    if (etat.proportion === "3:4") return 3 / 4;
    return 1;
  }

  /**
   * Dimensions du sticker fini, en centimètres.
   *
   * Sur une forme géométrique, elles se déduisent de la proportion choisie. Sur une
   * découpe à la forme, le serveur rogne la composition puis l'inscrit dans
   * l'encombrement : les dimensions dépendent alors de ce que le client a dessiné, et
   * c'est la silhouette mesurée par le canevas qui les donne. Sans elle, on annoncerait
   * un carré là où le client recevra un sticker deux fois plus large que haut.
   */
  function dimensionsCm() {
    var cote = etat.taille;
    if (etat.forme === "forme") {
      var bord = contourCm();
      var utile = Math.max(0.1, cote - 2 * bord);
      var r = silhouetteCourante && silhouetteCourante.h > 0
        ? (silhouetteCourante.l / silhouetteCourante.h) * ratioCadre()
        : 1;
      var l = r >= 1 ? utile : utile * r;
      var h = r >= 1 ? utile / r : utile;
      return {
        l: Math.round((l + 2 * bord) * 10) / 10,
        h: Math.round((h + 2 * bord) * 10) / 10
      };
    }
    var rf = ratioCadre();
    return rf >= 1
      ? { l: cote, h: Math.round((cote / rf) * 10) / 10 }
      : { l: Math.round(cote * rf * 10) / 10, h: cote };
  }

  /**
   * Le visuel, au singulier.
   *
   * L'éditeur n'en accepte plus qu'un, et le panneau s'ouvre sur lui et non sur la
   * sélection : un clic dans le vide désélectionne, et le retrait du fond disparaissait
   * avec la sélection alors que le visuel, lui, était toujours là.
   *
   * ⚠️ Le canevas sait toujours empiler des calques. On lit le premier visuel plutôt que
   * de supposer qu'il est seul, pour que rendre l'empilement ne casse rien ici.
   */
  function visuel() {
    var cs = canevas.calques();
    for (var i = 0; i < cs.length; i++) {
      if (cs[i].type === "image") return cs[i];
    }
    return null;
  }

  /**
   * Cadre le visuel dans le format, sans le déformer.
   *
   * Le client ne place plus son visuel : l'aperçu doit donc le cadrer comme le serveur le
   * cadrera, sans quoi il montrerait autre chose que le sticker livré.
   *
   * ⛔ LE VISUEL TIENT ENTIER DANS LA FORME, QUELLE QU'ELLE SOIT, avec du papier autour s'il
   * reste de la place. Choix de Jonathan le 20/08/2026, après avoir vu son logo réduit à deux
   * lettres dans un rond : le sticker n'ampute plus le visuel, c'est la matière qui comble.
   *
   * C'est bien ici que la décision se prend, et non côté serveur : l'éditeur compose le
   * document sur la boîte du sticker, puis le serveur remplit cette boîte et coupe à la
   * silhouette. Ce qui dépasse du cadre est donc perdu à la composition, avant même la
   * découpe — le placement du calque est le seul endroit qui puisse l'éviter.
   *
   * Trois géométries, parce que trois lames. L'ellipse est la plus exigeante : un rectangle
   * qui remplit le cadre y perd ses quatre coins.
   *
   * ⛔ SUR UNE DÉCOUPE À LA FORME, LE DESSIN S'ARRÊTE AVANT LE BORD : c'est le dessin PLUS
   * le liseré qui font le format commandé, jamais le dessin seul. Le serveur le dit sans
   * détour — `coteUtile = cote - 2 * contourPx` — et un 8 cm sortirait à 8,4 sans ce
   * retrait. Rempli jusqu'au bord, l'aperçu montrait un sticker plus grand que le format,
   * d'un excès qui changeait avec la taille : 10 % sur un 4 cm, 1,7 % sur un 24 cm. C'est
   * ce glissement que Jonathan a vu le 20/08/2026 en changeant de format.
   */
  function cadrer(calque) {
    if (!calque) return Promise.resolve(null);
    var s = sources[calque.srcId] || {};
    var rImg = (s.largeur && s.hauteur) ? s.largeur / s.hauteur : 1;
    var r = ratioCadre();
    // Le rapport du visuel dit dans le repère du cadre, où les fractions se rapportent à un
    // rectangle et non à un carré.
    var p = rImg / r;
    var l, h;
    if (etat.forme === "rond" || etat.forme === "ovale") {
      // Le plus grand rectangle de ce rapport INSCRIT DANS L'ELLIPSE, et non le rectangle
      // qui la contient : (l/1)² + (h/1)² = 1 pour une ellipse inscrite dans le cadre.
      // Remplir le cadre laisserait la lame emporter les quatre coins du visuel.
      h = 1 / Math.sqrt(p * p + 1);
      l = p * h;
    } else {
      l = 1;
      h = 1 / p;
      if (h > 1) { h = 1; l = p; }
    }
    if (etat.forme === "forme") {
      // La place du liseré, prise sur le dessin et non ajoutée autour. Le facteur porte sur
      // les deux côtés à la fois : le liseré borde la silhouette de partout, et n'écraser
      // qu'une dimension déformerait le visuel.
      var utile = Math.max(0.1, 1 - 2 * contourCm() / etat.taille);
      l *= utile;
      h *= utile;
    }
    return canevas.modifier(calque.id, { x: 0.5, y: 0.5, l: l, h: h, rot: 0 });
  }

  /**
   * Résolution du calque le plus faible, face au format demandé.
   *
   * On juge le pire, pas la moyenne : une photo nette et un logo pixellisé donnent un
   * sticker pixellisé. Les textes sont ignorés, ils sont vectoriels. Même calcul que
   * qualiteDocument() côté serveur — on prévient, on ne refuse pas.
   */
  function qualite() {
    var pire = null;
    canevas.calques().forEach(function (c) {
      if (c.type !== "image") return;
      var s = sources[c.srcId];
      if (!s || !s.largeur) return;
      var largeurCm = c.l * etat.taille;
      var hauteurCm = c.h * etat.taille;
      var dpi = Math.floor(Math.min(
        s.largeur / (largeurCm / 2.54),
        s.hauteur / (hauteurCm / 2.54)
      ));
      if (pire === null || dpi < pire) pire = dpi;
    });
    if (pire === null) return null;
    return { dpi: pire, niveau: pire < 150 ? "faible" : pire < 250 ? "correct" : "bon" };
  }

  /**
   * Mesure la composition et redessine le liseré.
   *
   * L'analyse lit les pixels d'un canvas puis dilate une silhouette : la refaire à
   * chaque frame d'un glissement serait ruineux. On attend que la main s'arrête.
   *
   * Le liseré est demandé en PROPORTION du côté utile, jamais en pixels d'écran. Le
   * serveur agrandit le motif pour remplir le format commandé : un dessin posé tout
   * petit ressortira grand, et son liseré de 2 mm paraîtra d'autant plus fin. C'est
   * ce rapport-là qu'il faut montrer, sous peine de promettre un bord qui ne sera pas
   * celui reçu.
   */
  var mesureEnAttente = null;
  function planifierMesure() {
    if (etat.forme !== "forme") {
      silhouetteCourante = null;
      // Une forme géométrique se borne toute seule : la scène est le sticker. Garder le
      // masque du dessin y découperait le papier en suivant le motif, au lieu du rond.
      masqueCourant = null;
      majLisere(null);
      majMatiere();
      return;
    }
    clearTimeout(mesureEnAttente);
    mesureEnAttente = setTimeout(function () {
      var utile = Math.max(0.1, etat.taille - 2 * contourCm());
      canevas.analyser(contourCm() / utile).then(function (r) {
        silhouetteCourante = r && r.boite;
        masqueCourant = (r && r.silhouette) || null;
        majLisere(r && r.lisere);
        majMatiere();
        majPrix();
        ajusterSurEncre(r && r.boite);
      }).catch(function () { /* la mesure n'est qu'un confort d'affichage */ });
    }, 160);
  }

  /**
   * Ramène le DESSIN à la taille utile du format — l'encre, pas le cadre du fichier.
   *
   * cadrer() ne connaît que le cadre du fichier, seul renseignement que le dépôt fournit.
   * Or le serveur rogne au dessin AVANT de l'agrandir : un visuel livré avec des marges
   * transparentes ressortait donc plus petit que le format à l'écran, et rien ne le disait.
   * Le logo d'Affichely porte 16 px de vide en haut et 50 en bas, si bien que son encre
   * n'occupait que 91 % du format au lieu de 95 ; sur un fichier plus généreusement margé,
   * le sticker aurait l'air perdu au milieu de son cadre.
   *
   * ⛔ ELLE RECENTRE SUR L'ENCRE, ET PAS SEULEMENT À CAUSE DU BON GOÛT. Le centre du dessin
   * n'est pas celui du fichier : le logo d'Affichely touche le bord gauche de son PNG et
   * laisse 47 px à droite. Agrandir autour du centre du CALQUE poussait donc l'encre hors du
   * cadre à gauche — mesuré à 24 cm, la lettre A sortait de 1,7 mm du liseré, qui manquait de
   * ce côté quand il faisait 2,6 mm de l'autre. Le trait de coupe aurait traversé la lettre.
   *
   * ⚠️ CETTE CORRECTION SE RAPPELLE ELLE-MÊME, par la mesure qu'elle relance. Elle ne boucle
   * pas pour trois raisons : une mise à l'échelle atteint sa cible du premier coup, un
   * recentrage aussi, et la tolérance arrête le second tour. Y toucher sans garder ces trois
   * propriétés ferait osciller l'aperçu sans fin.
   */
  function ajusterSurEncre(boite) {
    if (etat.forme !== "forme" || !boite) return;
    var c = visuel();
    if (!c) return;
    // La scène est carrée sur une découpe à la forme : la plus grande part de l'encre se
    // compare donc directement au côté utile.
    var atteint = Math.max(boite.l, boite.h);
    if (!(atteint > 0.01)) return;
    var facteur = Math.max(0.1, 1 - 2 * contourCm() / etat.taille) / atteint;
    // Où le dessin se tient dans la scène, une fois agrandi. La mise à l'échelle se fait
    // autour du centre du calque : l'écart de l'encre à ce centre grandit du même facteur.
    var x = 0.5 - (boite.x + boite.l / 2 - c.x) * facteur;
    var y = 0.5 - (boite.y + boite.h / 2 - c.y) * facteur;
    if (Math.abs(facteur - 1) < 0.015 &&
        Math.abs(x - c.x) < 0.004 && Math.abs(y - c.y) < 0.004) return;
    canevas.modifier(c.id, { l: c.l * facteur, h: c.h * facteur, x: x, y: y });
  }

  /** Pose — ou retire — l'image du liseré derrière les calques. */
  function majLisere(lisere) {
    var el = $("[data-cv-lisere]");
    if (!el) return;
    if (!lisere) {
      el.hidden = true;
      el.style.backgroundImage = "";
      return;
    }
    el.hidden = false;
    el.style.inset = (-lisere.marge * 100) + "%";
    el.style.backgroundImage = "url(" + lisere.url + ")";
  }

  /**
   * Peint le papier choisi, et le reflet qui court dessus.
   *
   * Le papier n'apparaît que là où il se verra sur le sticker livré : au liseré, qui est
   * du vinyle nu, et sous les transparences du dessin. Une photo qui couvre tout le
   * cache, et c'est juste — le support est derrière l'encre, pas devant.
   *
   * Deux façons de le borner, selon la découpe. Une forme géométrique est bornée par la
   * scène elle-même, dont le rectangle EST le sticker : le CSS l'arrondit en ellipse
   * quand il le faut. Une découpe à la forme, elle, n'a de contour qu'une fois la
   * silhouette mesurée par le canevas, et c'est ce masque-là qui la borne. Tant qu'il
   * n'est pas connu, on ne peint rien : un rectangle holographique posé sur tout le
   * cadre annoncerait un sticker carré alors que la lame suivra le dessin.
   *
   * Rien de ceci ne part à l'impression. Le fichier d'impression ne porte que le dessin,
   * et c'est le vinyle commandé qui apporte l'éclat.
   */
  function majMatiere() {
    var mat = $("[data-cv-matiere]");
    var ver = $("[data-cv-vernis]");
    if (!mat || !ver) return;

    mat.setAttribute("data-papier", etat.papier);
    ver.setAttribute("data-lam", etat.lamination ? "1" : "0");
    /*
     * ⛔ LA FINITION EST AUSSI POSÉE SUR LE PLAN, et pas seulement sur le reflet. Une
     * pellicule mate dépolit la matière qui est DESSOUS : le papier est un frère aîné du
     * reflet dans le DOM, aucun sélecteur ne remonte de l'un à l'autre. L'attribut sur
     * l'ancêtre commun est ce qui permet à la feuille de style d'atteindre les deux.
     */
    var plan = $("[data-cv-plan]");
    if (plan) plan.setAttribute("data-lam", etat.lamination ? "1" : "0");

    var aForme = etat.forme === "forme";
    var pret = !canevas.vide() && (!aForme || !!masqueCourant);
    mat.hidden = !pret;
    ver.hidden = !pret;
    if (!pret) return;

    var bord = aForme ? (-masqueCourant.marge * 100) + "%" : "0";
    var masque = aForme ? "url(" + masqueCourant.url + ")" : "";
    [mat, ver].forEach(function (el) {
      el.style.inset = bord;
      // Le préfixe reste : Safari ne comprend `mask-image` que depuis peu, et un papier
      // holographique débordant du sticker vaut moins qu'un préfixe de trop.
      el.style.webkitMaskImage = masque;
      el.style.maskImage = masque;
      if (!masque) return;
      el.style.webkitMaskSize = "100% 100%";
      el.style.maskSize = "100% 100%";
      el.style.webkitMaskRepeat = "no-repeat";
      el.style.maskRepeat = "no-repeat";
    });
  }

  // --- Rendu de l'interface ----------------------------------------------------
  function majPills() {
    $$("[data-sticker-opt]").forEach(function (grp) {
      var cle = grp.getAttribute("data-sticker-opt");
      grp.querySelectorAll("[data-value]").forEach(function (b) {
        var v = b.getAttribute("data-value");
        var actif = cle === "lam"
          ? (v === "1") === etat.lamination
          : String(etat[cle]) === v;
        b.setAttribute("aria-pressed", actif ? "true" : "false");
      });
    });

    // Le choix de proportion n'a de sens que pour les formes géométriques : une ellipse
    // inscrite dans un carré est un rond, et la découpe à la forme suit la silhouette.
    var bloc = $("[data-sticker-row='proportion']");
    if (bloc) bloc.hidden = etat.forme === "rond" || etat.forme === "forme";

    var carre = $("[data-sticker-opt='proportion'] [data-value='1:1']");
    if (carre) carre.hidden = etat.forme === "ovale";

    // Les coins ne concernent que le rectangle : un rond n'en a pas, et la lame d'une découpe
    // à la forme suit un contour qu'elle n'arrondit pas.
    var rangeeCoins = $("[data-sticker-row='coins']");
    if (rangeeCoins) rangeeCoins.hidden = etat.forme !== "rect";

    /*
     * ⛔ SUR L'HOLOGRAPHIQUE, IL N'Y A PLUS RIEN À CHOISIR. Jonathan, 21/08/2026 : « retire
     * l'option de finition sur Holographique ». Le film part sans pellicule, donc au tarif du
     * papier seul, et l'aperçu le montre mat comme tout sticker non laminé.
     *
     * ⚠️ LA RANGÉE EST REMPLACÉE, PAS SEULEMENT RETIRÉE. Une option qui disparaît sans un mot se
     * lit comme une panne : la phrase qui prend sa place dit que la question ne se pose pas.
     */
    var sansFinition = etat.papier === "holo";
    var rangeeLam = $("[data-sticker-row='lam']");
    if (rangeeLam) rangeeLam.hidden = sansFinition;
    var noteLam = $("[data-sticker-row='lam-holo']");
    if (noteLam) noteLam.hidden = !sansFinition;
  }

  /**
   * Arrondit les coins de l'aperçu, exactement comme la lame les coupera.
   *
   * ⛔ DEUX POURCENTAGES POUR UN RAYON ROND, et c'est tout l'objet de cette fonction. En CSS,
   * `border-radius: 8%` se rapporte à la LARGEUR pour l'horizontale et à la HAUTEUR pour la
   * verticale : sur un 4:3, le coin sortirait elliptique quand le serveur, lui, pose un `rx`
   * circulaire. On convertit donc le rayon — une part du petit côté — en la part que chaque axe
   * doit lui accorder.
   *
   * ⚠️ RIEN NE SE MESURE ICI EN PIXELS. On ne pose que des pourcentages tirés du rapport du
   * sticker : l'arrondi reste juste à tout redimensionnement de la fenêtre, sans écouter le
   * moindre évènement, et il ne change pas d'un format à l'autre.
   */
  function majCoins() {
    var plan = $("[data-cv-plan]");
    var scene = $("[data-cv-scene]");
    if (!plan || !scene) return;
    plan.setAttribute("data-coins", etat.coins === "arrondis" ? "arrondis" : "vifs");
    var r = ratioCadre();
    scene.style.setProperty("--cv-rayon-h", (RAYON_RELATIF * 100 / Math.max(r, 1)) + "%");
    scene.style.setProperty("--cv-rayon-v", (RAYON_RELATIF * 100 * Math.min(r, 1)) + "%");
  }

  function majPrix() {
    // Le prix unitaire de chaque palier est affiché sur la pastille : c'est ce qui rend
    // la dégressivité lisible, et c'est le principal argument de montée en quantité.
    $$("[data-sticker-opt='qte'] [data-value]").forEach(function (b) {
      var q = parseInt(b.getAttribute("data-value"), 10);
      var u = prixUnitaire(grille, {
        qte: q, taille: etat.taille, papier: etat.papier,
        forme: etat.forme, lamination: etat.lamination
      });
      var sous = b.querySelector("small");
      if (sous) sous.textContent = money(Math.round(u * 100)) + " " + T("par_unite", "/u");
    });

    var unitaire = prixUnitaire(grille, etat);
    var total = totalCentimes(grille, etat);
    var elTotal = $("[data-sticker-total]");
    var elUnit = $("[data-sticker-unit]");
    var elAdd = $("[data-sticker-add]");
    if (elTotal) elTotal.textContent = money(total);
    if (elUnit) {
      elUnit.textContent = T("soit", "soit") + " " + money(Math.round(unitaire * 100))
        + " " + T("unite_piece", "par sticker");
    }
    if (elAdd) elAdd.textContent = T("ajouter", "Ajouter au panier") + " · " + money(total);
    // La barre collée du téléphone porte le total, et non le prix unitaire : c'est la
    // somme qui décide au moment de payer, et son bouton n'a pas la place de la répéter.
    var elBarrePrix = $("[data-sticker-barre-prix]");
    if (elBarrePrix) elBarrePrix.textContent = money(total);
    majBarre();

    // La pastille dit ce qu'elle mesure. Sans ce mot, on la confondait avec le format
    // commandé, qui est écrit sur le cadre juste au-dessus et ne vaut pas la même chose
    // dès que la découpe suit la forme du dessin.
    var d = dimensionsCm();
    var elDims = $("[data-sticker-dims]");
    if (elDims) {
      elDims.textContent = T("mesure_fini", "Votre sticker") + " · "
        + cm(d.l) + " × " + cm(d.h) + " cm";
    }

    // Le liseré n'a plus de cote affichée : il n'est plus un choix, et son épaisseur suit le
    // format sans que le client ait à la lire. La ligne de mesures dit ce qu'il commande —
    // les dimensions finies — et non comment le fichier est construit.

    var q = qualite();
    var elQ = $("[data-sticker-quality]");
    if (elQ) {
      if (!q) { elQ.hidden = true; }
      else {
        elQ.hidden = false;
        elQ.setAttribute("data-niveau", q.niveau);
        elQ.textContent = T("qualite_" + q.niveau, q.niveau) + " · " + q.dpi + " dpi";
      }
    }
  }

  /**
   * Voile : hors de ce tracé, rien ne sera imprimé.
   *
   * Un rectangle plein percé de la forme, en règle de remplissage « pair-impair ».
   * L'aperçu ne rogne donc rien : le client voit qu'il peut déborder, et jusqu'où.
   *
   * La découpe à la forme en a besoin autant que les autres, quoique pour une raison
   * différente. Son tracé de coupe suit la silhouette, mais la composition, elle,
   * reste bornée par l'encombrement commandé — un texte glissé hors du cadre
   * disparaissait purement et simplement du fichier d'impression, sans que rien à
   * l'écran ne l'ait laissé prévoir.
   */
  function majVoile() {
    var plan = $("[data-cv-plan]");
    var voile = $("[data-cv-voile]");
    var scene = $("[data-cv-scene]");
    if (!plan || !voile || !scene) return;

    plan.setAttribute("data-forme", etat.forme);
    plan.setAttribute("data-vide", canevas.vide() ? "true" : "false");

    // Pendant le relief, la scène est tournée dans l'espace : sa boîte à l'écran n'est
    // plus son rectangle, et le voile s'en trouverait placé de travers. Il est de toute
    // façon masqué à ce moment-là, et redessiné au retour à plat.
    if (relief) return;

    var p = plan.getBoundingClientRect();
    var s = scene.getBoundingClientRect();
    if (!p.width || !s.width) return;
    var x = s.left - p.left, y = s.top - p.top, l = s.width, h = s.height;

    // Sur une découpe à la forme, la limite est le cadre lui-même : la coupe, elle,
    // se fera sur la silhouette, que l'aperçu montre déjà par son liseré blanc.
    var rond = etat.forme === "rond" || etat.forme === "ovale";
    // Le rayon se mesure sur le PLUS PETIT côté, comme au serveur : c'est ce qui l'empêche de
    // dégénérer en pastille sur un rectangle très allongé.
    var rayon = etat.forme === "rect" && etat.coins === "arrondis"
      ? RAYON_RELATIF * Math.min(l, h) : 0;
    var trou = rond
      ? "M" + x + " " + (y + h / 2) +
        "a" + (l / 2) + " " + (h / 2) + " 0 1 0 " + l + " 0" +
        "a" + (l / 2) + " " + (h / 2) + " 0 1 0 " + (-l) + " 0Z"
      : rayon > 0
        ? cheminArrondi(x, y, l, h, rayon)
        : "M" + x + " " + y + "h" + l + "v" + h + "h" + (-l) + "Z";

    // Le trait est nommé, sans quoi on ne sait pas ce qu'il mesure. Sur une découpe à
    // la forme il borne l'impression sans être la coupe ; sur les autres il est la
    // coupe elle-même. Deux sens, deux libellés — et les dimensions écrites dessus,
    // car c'est la question qu'on se pose en le regardant.
    var cadre = cadreCm();
    var etiquette = (etat.forme === "forme"
      ? T("plan_commande", "Format commandé")
      : T("plan_decoupe", "Découpe"))
      + " · " + cm(cadre.l) + " × " + cm(cadre.h) + " cm";

    voile.innerHTML =
      '<svg viewBox="0 0 ' + p.width + ' ' + p.height + '" preserveAspectRatio="none">' +
      '<path class="cv-voile__hors" fill-rule="evenodd" d="M0 0h' + p.width + 'v' + p.height + 'H0Z' + trou + '"/>' +
      '<path class="cv-voile__trait" d="' + trou + '"/></svg>';

    var note = document.createElement("span");
    note.className = "cv-voile__cote";
    note.textContent = etiquette;
    note.style.left = (x + l / 2) + "px";
    note.style.top = y + "px";
    voile.appendChild(note);
  }

  /**
   * Le tour d'un rectangle à coins arrondis, en quatre droites et quatre quarts de cercle.
   *
   * Les arcs sont des quarts de CERCLE et non d'ellipse — mêmes rayons sur les deux axes —
   * parce que c'est ce que la lame parcourt : `sticker-render.silhouetteGeometrique` pose un
   * `rx` égal à son `ry`.
   */
  function cheminArrondi(x, y, l, h, r) {
    var arc = "a" + r + " " + r + " 0 0 1 ";
    return "M" + (x + r) + " " + y +
      "h" + (l - 2 * r) + arc + r + " " + r +
      "v" + (h - 2 * r) + arc + (-r) + " " + r +
      "h" + (-(l - 2 * r)) + arc + (-r) + " " + (-r) +
      "v" + (-(h - 2 * r)) + arc + r + " " + (-r) + "Z";
  }

  /** Dimensions du cadre commandé, tel que le trait le dessine. */
  function cadreCm() {
    var r = ratioCadre();
    var cote = etat.taille;
    return r >= 1
      ? { l: cote, h: Math.round((cote / r) * 10) / 10 }
      : { l: Math.round(cote * r * 10) / 10, h: cote };
  }

  /** Un nombre de centimètres tel qu'on l'écrit en français. */
  function cm(v) { return String(v).replace(".", ","); }

  function maj() {
    // Le relief n'est plus un détour, c'est l'état normal de l'aperçu : dès qu'un visuel
    // arrive, le sticker se montre incliné, matière comprise. Il ne se referme que sur un
    // cadre vide, où il n'y aurait qu'un rectangle à faire tourner.
    var incliner = !canevas.vide();
    if (incliner !== relief) basculerRelief(incliner);
    majSupport();
    majCoins();
    majPills(); majPrix(); majVoile(); majMatiere(); verrou(enCours);
  }

  /**
   * Pose le support choisi derrière le sticker, et l'y colle à sa vraie taille.
   *
   * ⛔ SANS SUPPORT, LE FORMAT NE CHANGE RIEN À L'ÉCRAN, et c'est une consigne, pas un effet
   * de bord. Demande de Jonathan le 20/08/2026 : « quand on change de taille du format, je ne
   * veux aucune modification visuelle, ça doit juste changer la taille du fichier de sortie ».
   * Le sticker remplit donc le plan à tous les formats — le liseré étant lui aussi devenu une
   * part du format, il ne reste rien qui puisse bouger. Ce qui a précédé et qui n'a pas
   * convaincu : un quadrillage centimétrique, puis une règle graduée le long d'une vignette à
   * l'échelle. Les deux disaient la taille en la faisant lire ; celui-ci la fait voir.
   *
   * ⛔ ET AVEC UN SUPPORT, LA TAILLE EST LA SEULE CHOSE QUI CHANGE. Le dessin du support est
   * à sa mesure réelle — un capot de portable fait 30,4 cm, une porte de frigo 60 — et il
   * couvre exactement la boîte de contenu du plan. La part que le sticker y occupe est donc
   * le simple rapport des deux largeurs, et un 4 cm sur un frigo est bien le quinzième de la
   * porte, comme dans la cuisine du client.
   *
   * ⚠️ RIEN NE SE MESURE ICI EN PIXELS. On ne pose qu'un nombre sans unité, dont la feuille
   * de style tire une largeur en pourcentage : l'échelle reste juste à tout redimensionnement
   * de la fenêtre, sans écouter le moindre évènement.
   *
   * ⚠️ LA MESURE DU SUPPORT SE LIT DANS LE BALISAGE (`data-cm`), elle n'est pas écrite ici.
   * Le dessin et sa cote doivent rester côte à côte : redessiner un capot plus large en
   * oubliant de corriger un nombre en JavaScript ferait mentir l'échelle sans rien casser.
   */
  function majSupport() {
    var plan = $("[data-cv-plan]");
    var scene = $("[data-cv-scene]");
    if (!plan || !scene) return;
    plan.setAttribute("data-support", etat.support);
    var dessin = $("[data-cv-support='" + etat.support + "']");
    var large = dessin ? parseFloat(dessin.getAttribute("data-cm")) : 0;
    scene.style.setProperty("--cv-echelle", large > 0 ? String(etat.taille / large) : "1");
  }

  function statut(msg, type) {
    var el = $("[data-sticker-status]");
    if (!el) return;
    el.textContent = msg || "";
    el.hidden = !msg;
    el.setAttribute("data-type", type || "info");
  }

  function verrou(on) {
    enCours = on;
    var b = $("[data-sticker-add]");
    if (b) b.disabled = on || canevas.vide();
    root.setAttribute("data-etape", canevas.vide() ? "upload" : "config");
    root.setAttribute("data-busy", on ? "true" : "false");
    majBarre();
  }

  /**
   * Le bouton de la barre collée du téléphone.
   *
   * ⛔ IL NE SE GRISE PAS QUAND LE PLAN EST VIDE, à la différence de celui de la fiche.
   * Un bouton mort au ras de l'écran ne dit rien de ce qu'on attend : tant qu'aucun visuel
   * n'est arrivé, il porte donc le geste qui manque et ouvre le sélecteur de fichiers. Seul
   * un envoi en cours l'immobilise, le temps que le fichier arrive.
   *
   * Les deux libellés viennent du balisage, comme sur la fiche affiche : ils sont traduits
   * par Liquid dans les treize langues, et le script n'a pas à connaître leur texte.
   */
  function majBarre() {
    var b = $("[data-sticker-barre-add]");
    if (!b) return;
    var vide = canevas.vide();
    var libelle = b.getAttribute(vide ? "data-label-import" : "data-label-add");
    if (libelle) b.textContent = libelle;
    b.disabled = enCours;
    /* L'arrivée d'un visuel change l'ancre de la barre — le bouton d'import cède la place au
       bouton d'achat, à un écran de là — et la hauteur de la page avec elle. Sans ce rappel,
       la barre gardait le jugement porté sur une ancre qui n'est plus la bonne. */
    if (jugerBarre) jugerBarre();
  }

  // Posée par la barre elle-même, plus bas : elle n'existe que si le balisage la porte.
  var jugerBarre = null;

  // --- Panneau du calque choisi -------------------------------------------------

  function majPanneau(calque) {
    var panneau = $("[data-cv-panneau]");
    if (!panneau) return;
    panneau.hidden = !calque;
    if (!calque) return;
    // Les deux blocs se cherchent, ils ne s'exigent pas : celui du texte a quitté le
    // balisage avec l'outil, et le code qui le remplit reste là, en veille, pour le jour
    // où le texte reviendrait.
    var blocTexte = $("[data-cv-bloc='texte']");
    if (blocTexte) blocTexte.hidden = calque.type !== "texte";
    var blocImage = $("[data-cv-bloc='image']");
    if (blocImage) blocImage.hidden = calque.type !== "image";
    majZoom(calque);

    if (calque.type === "image") {
      // Un visuel livré sans fond n'a rien à détourer : sa transparence dessine déjà
      // la découpe. Proposer le choix ferait douter d'une étape à ne pas oublier.
      //
      // La rangée s'efface, et RIEN NE PREND SA PLACE : la phrase « ce visuel est déjà sans
      // fond » a été retirée le 21/08/2026 sur demande de Jonathan. Elle commentait une
      // absence, ce qui la rendait plus bavarde que le vide qu'elle expliquait.
      var s = sources[calque.srcId] || {};
      var champ = $("[data-cv-champ='fond']");
      if (champ) champ.hidden = !!s.transparent;
      $$("[data-cv-fond]").forEach(function (b) {
        var veutDetourer = b.getAttribute("data-cv-fond") === "detoure";
        b.setAttribute("aria-pressed", veutDetourer === !!calque.detoure ? "true" : "false");
        // Détourer sans le service serait un bouton qui ment. Garder le fond, lui,
        // reste toujours possible : c'est l'état de l'image telle qu'elle est arrivée.
        b.disabled = veutDetourer && detourageEteint;
      });
      return;
    }
    if (calque.type !== "texte") return;

    var champ = $("[data-cv-texte]");
    if (champ && champ.value !== calque.contenu) champ.value = calque.contenu;
    $$("[data-cv-polices] [data-police]").forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-police") === calque.police ? "true" : "false");
    });
    $$("[data-cv-couleurs] [data-couleur]").forEach(function (b) {
      b.setAttribute("aria-pressed", b.getAttribute("data-couleur") === calque.couleur ? "true" : "false");
    });
    $$("[data-cv-contours] [data-contour]").forEach(function (b) {
      var v = b.getAttribute("data-contour");
      var actif = v === "" ? !calque.contour : v === calque.contour;
      b.setAttribute("aria-pressed", actif ? "true" : "false");
    });
  }

  /**
   * Sélecteur de polices : chaque bouton montre son nom dans sa propre lettre.
   *
   * Le rendu passe par opentype.js, comme le texte du canevas — la même vectorisation
   * pour l'aperçu du choix et pour le fichier d'impression. Aucune police web n'est
   * donc déclarée, et les fichiers ne se chargent qu'à l'approche du bouton : les
   * douze réunies pèsent un demi-méga, qu'il serait déraisonnable d'imposer d'emblée
   * à une connexion mobile.
   */
  function monterPolices() {
    var hote = $("[data-cv-polices]");
    if (!hote) return;
    var vus = new (window.IntersectionObserver || function () {})(function (entrees, obs) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        peindrePolice(e.target);
      });
    }, { root: hote, rootMargin: "120px" });

    canevas.polices.forEach(function (p) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cv-police";
      b.setAttribute("data-police", p.id);
      b.setAttribute("aria-pressed", "false");
      b.setAttribute("aria-label", p.nom);
      b.innerHTML = '<span class="cv-police__attente">' + p.nom + "</span>";
      hote.appendChild(b);
      if (vus.observe) vus.observe(b); else peindrePolice(b);
    });
  }

  function peindrePolice(bouton) {
    var id = bouton.getAttribute("data-police");
    var nom = bouton.getAttribute("aria-label");
    canevas.chargerPolice(id).then(function (police) {
      var v = canevas.vectoriser(police, nom, "centre");
      bouton.innerHTML =
        '<svg viewBox="0 0 ' + v.cheminL + " " + v.cheminH + '" preserveAspectRatio="xMidYMid meet">' +
        '<path d="' + v.chemin + '"/></svg>';
    }).catch(function () {
      // Le nom reste lisible dans la police de la boutique : le choix est dégradé,
      // pas perdu.
      bouton.querySelector(".cv-police__attente").textContent = nom;
    });
  }

  function monterCouleurs() {
    var remplir = function (hote, attribut, avecNulle) {
      if (!hote) return;
      if (avecNulle) {
        var n = document.createElement("button");
        n.type = "button";
        n.className = "cv-couleur cv-couleur--nulle";
        n.setAttribute(attribut, "");
        n.setAttribute("aria-label", T("texte_sans_contour", "Sans contour"));
        hote.appendChild(n);
      }
      COULEURS.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cv-couleur";
        b.style.background = c;
        b.setAttribute(attribut, c);
        b.setAttribute("aria-label", c);
        hote.appendChild(b);
      });
    };
    remplir($("[data-cv-couleurs]"), "data-couleur", false);
    remplir($("[data-cv-contours]"), "data-contour", true);
  }

  // --- Échanges avec l'app -----------------------------------------------------

  /* ⛔ LE REFUS SE COMPTE, IL NE SE DEDUIT PAS DU VIDE. Trappe corrigee le 15/08/2026 apres
     le message d'un client neerlandais : l'ancien code n'avertissait QUE si la liste retenue
     etait vide. Un visuel en HEIC disparaissait donc sans un mot, et le client voyait un
     dessin incomplet sans savoir pourquoi.

     ⚠️ LE CHAMP N'EST PLUS `multiple` : le navigateur ne rend qu'un fichier, et il n'y a plus
     de chaine d'envois. Le comptage reste, car un fichier unique peut etre refuse tout autant,
     et c'est ce cas-la que le silence rendait incomprehensible. */
  function deposer(fichiers) {
    var tous = Array.prototype.slice.call(fichiers);
    var liste = tous.filter(function (f) { return /^image\/(jpeg|png)$/.test(f.type); });
    var refuses = tous.filter(function (f) { return liste.indexOf(f) === -1; })
      .map(function (f) { return f.name || ""; }).filter(Boolean);
    if (refuses.length) {
      statut(T("fichiers_refuses", "Ces visuels n'ont pas pu être lus, ils n'ont pas été ajoutés : ")
        + refuses.join(", "), "erreur");
    }
    if (!liste.length) {
      if (!refuses.length) statut(T("mauvais_type", "Format non accepté : importez un JPG ou un PNG"), "erreur");
      return Promise.resolve();
    }

    verrou(true);
    statut(T("envoi", "Envoi du visuel…"), "info");
    return fetch(API + "/sticker/upload", {
      method: "POST",
      headers: { "Content-Type": liste[0].type },
      body: liste[0]
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().catch(function () { return {}; }).then(function (j) {
        throw new Error(j.error || String(r.status));
      });
    }).then(function (j) {
      sources[j.id] = {
        url: j.url, cut: null, largeur: j.largeur, hauteur: j.hauteur,
        // Mesurée par le serveur, qui lit le fichier entier. La deviner ici
        // supposerait de redessiner l'image dans un canvas réduit, où quelques
        // pixels transparents se perdraient dans la moyenne.
        transparent: !!j.transparent
      };
      // Le nouveau visuel REMPLACE l'ancien. Les empiler sans que rien ne permette de
      // les départager donnerait un dessin caché sous un autre, et le client chercherait
      // longtemps ce qu'il a perdu.
      canevas.calques().forEach(function (c) {
        if (c.type === "image") canevas.supprimer(c.id);
      });
      var c = canevas.ajouterImage(j.id, sources[j.id]);
      // Cadré d'office : le client ne le place plus, c'est donc à l'aperçu de le poser
      // comme le serveur le posera.
      return cadrer(c);
    })
      .then(function () {
        statut("", "info");
        verrou(false);
        // Le visuel arrive tel qu'il a été importé, fond compris. Le détourer d'office
        // faisait disparaître le décor de photos qu'on voulait garder entier, et il
        // fallait deviner d'où venait la perte.
      })
      .catch(function (e) {
        verrou(false);
        var m = String(e.message || "");
        statut(
          m === "too_large" ? T("trop_lourd", "Fichier trop lourd (30 Mo maximum)")
            : m === "unsupported_type" ? T("mauvais_type", "Format non accepté : importez un JPG ou un PNG")
              : T("envoi_ko", "Envoi impossible, réessayez"),
          "erreur"
        );
      });
  }

  /**
   * Retire ou rend le fond d'un calque image.
   *
   * Rien n'est détouré à l'import, ni au choix d'une découpe : une photo importée avec
   * son fond doit rester telle quelle tant qu'on ne l'a pas demandé. Le détourage est
   * un geste, sur un calque désigné, et il s'annule — le fichier détouré reste en
   * mémoire à côté de l'original, si bien que la bascule est instantanée dans les deux
   * sens et n'appelle le service qu'une fois.
   */
  function changerFond(calque, detoure) {
    if (!calque || calque.type !== "image") return Promise.resolve();
    var s = sources[calque.srcId];
    if (!detoure || (s && s.cut)) {
      canevas.detourer(calque.id, detoure, null);
      planifierMesure();
      maj();
      majPanneau(visuel());
      return Promise.resolve();
    }

    verrou(true);
    statut(T("detourage", "Détourage du visuel…"), "info");
    return fetch(API + "/sticker/cutout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: calque.srcId })
    }).then(function (r) {
      if (r.ok) return r.json();
      throw new Error(String(r.status));
    }).then(function (j) {
      sources[calque.srcId].cut = j.apercu || j.url;
      canevas.detourer(calque.id, true, sources[calque.srcId].cut);
      statut("", "info");
      verrou(false);
      planifierMesure();
      maj();
      majPanneau(visuel());
    }).catch(function () {
      // Le fond reste : c'est un service en moins, pas une commande perdue. La découpe
      // à la forme, elle, n'a plus besoin du détourage — elle suivra le bord du visuel.
      verrou(false);
      statut(T("detourage_ko", "Détourage momentanément indisponible"), "erreur");
      majPanneau(visuel());
    });
  }

  function fabriquerFichier() {
    return fetch(API + "/sticker/document", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        document: canevas.exporter(),
        forme: etat.forme,
        // Les coins font partie du FICHIER : le serveur arrondit la silhouette, et son empreinte
        // les compte. Sans eux, un rectangle arrondi et le même à coins vifs partageraient un
        // nom de fichier, et l'atelier imprimerait l'autre.
        coins: etat.coins,
        tailleCm: etat.taille
      })
    }).then(function (r) {
      if (r.ok) return r.json();
      // Le code d'erreur de l'app plutôt que le seul statut HTTP : c'est lui qui
      // distingue un détourage absent d'un document refusé, et il finit dans la
      // console, seul endroit où l'on pourra nommer la panne après coup.
      return r.json().catch(function () { return {}; }).then(function (j) {
        throw new Error(j.detail || j.error || "http_" + r.status);
      });
    });
  }

  // --- Panier -------------------------------------------------------------------
  var LIBELLE_FORME = { forme: "À la forme", rond: "Rond", ovale: "Ovale", rect: "Rectangle" };
  var LIBELLE_PAPIER = { blanc: "Blanc", holo: "Holographique" };

  /** La découpe telle qu'elle s'écrit au panier, coins compris s'ils ont été demandés. */
  function libelleDecoupe() {
    var nom = LIBELLE_FORME[etat.forme] || etat.forme;
    // Les coins ne se disent que là où ils existent : « Rond à coins arrondis » ne veut rien
    // dire, et une mention de trop sur la confirmation de commande se lit comme une erreur.
    if (etat.forme === "rect" && etat.coins === "arrondis") nom += " à coins arrondis";
    return nom;
  }

  /** Résumé de la composition, pour le panier et pour l'atelier. */
  function resumeComposition() {
    var calques = canevas.calques();
    var visuels = calques.filter(function (c) { return c.type === "image"; }).length;
    var textes = calques.filter(function (c) { return c.type === "texte"; });
    var bouts = [];
    if (visuels) bouts.push(visuels + " " + T("composition_visuels", "visuel(s)"));
    if (textes.length) {
      bouts.push(textes.length + " " + T("composition_textes", "texte(s)"));
      // Le libellé des textes part avec la commande : c'est ce qui permet à l'atelier
      // de relire une faute de frappe avant de lancer cinq cents exemplaires.
      var mots = textes.map(function (c) { return c.contenu.replace(/\n/g, " "); })
        .filter(Boolean).join(" · ");
      if (mots) bouts.push("« " + mots.slice(0, 120) + " »");
    }
    return bouts.join(" · ");
  }

  function ajouterAuPanier() {
    if (enCours || canevas.vide() || !VARIANT) return;
    verrou(true);
    statut(T("preparation", "Préparation de votre fichier d'impression…"), "info");

    fabriquerFichier()
      .then(function (rendu) {
        var d = dimensionsCm();
        var unitaire = prixUnitaire(grille, etat);
        var props = {};
        // Visible par le client, dans le panier et sur la confirmation.
        props[T("prop_decoupe", "Découpe")] = libelleDecoupe();
        props[T("prop_format", "Format")] = etat.taille + " × " + etat.taille + " cm"
          + (d.l !== d.h ? " (" + String(d.l).replace(".", ",") + " × " + String(d.h).replace(".", ",") + " cm)" : "");
        // Le liseré ne figure plus au panier : il n'est plus un choix, et le serveur le
        // déduit du format des deux côtés — `sticker-commande.js` le récrit pour l'atelier.
        // L'annoncer ici obligerait à tenir le même nombre à un troisième endroit.
        props[T("prop_papier", "Papier")] = LIBELLE_PAPIER[etat.papier] || etat.papier;
        props[T("prop_finition", "Finition")] = etat.lamination
          ? T("avec_lam", "Avec lamination") : T("sans_lam", "Sans lamination");
        props[T("prop_quantite", "Quantité")] = etat.qte + " " + T("exemplaires", "exemplaires");
        var resume = resumeComposition();
        if (resume) props[T("prop_composition", "Composition")] = resume;

        // Techniques, masquées au client. Le Cart Transform relit ces cinq clés pour
        // recalculer le prix côté serveur : ce sont elles qui font foi, pas le total
        // affiché ici.
        props["_sticker"] = "1";
        props["_sticker_forme"] = etat.forme;
        // Les coins ne partent que sur un rectangle : ailleurs, la propriété annoncerait à
        // l'atelier un arrondi que la lame ne coupe pas. Le prix, lui, ne les regarde pas — le
        // Cart Transform ne lit pas cette clé.
        if (etat.forme === "rect") props["_sticker_coins"] = etat.coins;
        props["_sticker_taille"] = String(etat.taille);
        props["_sticker_papier"] = etat.papier;
        props["_sticker_lam"] = etat.lamination ? "1" : "0";
        props["_sticker_qte"] = String(etat.qte);
        // Trace du prix annoncé : si un jour la Function et l'éditeur divergent, la
        // commande garde de quoi arbitrer.
        props["_sticker_unitaire"] = unitaire.toFixed(2);
        props["_sticker_print_url"] = rendu.url;
        // Vignette du panier : la composition rendue par le serveur, et non plus le
        // fichier d'origine — sur un document de plusieurs calques, il ne montrerait
        // qu'un morceau de ce que le client a commandé.
        props["_sticker_preview"] = rendu.apercu || rendu.url;

        return window.murAddToCart({ items: [{ id: VARIANT, quantity: 1, properties: props }] });
      })
      .then(function () {
        verrou(false);
        statut("", "info");
      })
      .catch(function (e) {
        verrou(false);
        var m = String((e && e.message) || e);
        // Le client n'a que faire du code interne, mais sans trace nous en serions
        // réduits à deviner : toutes les pannes se ressemblent à l'écran.
        if (window.console && console.error) {
          console.error("sticker : ajout au panier impossible —", m, e);
        }
        // Un calque réclame un détourage dont le fichier a disparu du coffre. Le seul
        // remède est de le redemander, ou de garder le fond : c'est ce que dit le
        // message, plutôt que d'accuser la préparation du fichier.
        statut(
          m === "detourage_requis"
            ? T("detourage_ko", "Détourage momentanément indisponible")
            : T("panier_ko", "Impossible de préparer le fichier, réessayez"),
          "erreur"
        );
      });
  }

  // --- Écoute ---------------------------------------------------------------------

  var champ = $("[data-sticker-file]");
  if (champ) {
    champ.addEventListener("change", function (e) {
      if (e.target.files && e.target.files.length) deposer(e.target.files);
      // Vidé pour que réimporter deux fois le même fichier déclenche bien l'événement.
      e.target.value = "";
    });
  }

  $$("[data-cv-outil]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (b.getAttribute("data-cv-outil") === "image") {
        if (champ) champ.click();
        return;
      }
      canevas.ajouterTexte(T("texte_defaut", "Votre texte"), { police: "bebas" })
        .then(function () {
          var t = $("[data-cv-texte]");
          if (t) { t.focus(); t.select(); }
        })
        .catch(function () {
          statut(T("police_ko", "Polices momentanément indisponibles"), "erreur");
        });
    });
  });

  var saisie = $("[data-cv-texte]");
  if (saisie) {
    saisie.addEventListener("input", function () {
      var c = canevas.selection();
      if (c && c.type === "texte") canevas.modifier(c.id, { contenu: saisie.value });
    });
  }

  var panneau = $("[data-cv-panneau]");
  if (panneau) {
    panneau.addEventListener("click", function (e) {
      // Le visuel, et non la sélection : seuls les réglages d'image sont encore affichés.
      // Les branches de texte qui suivent sont hors d'atteinte tant que le rail n'existe
      // pas ; leur rendre la sélection suffirait à les réveiller.
      var c = visuel();
      if (!c) return;
      var police = e.target.closest("[data-police]");
      if (police) return void canevas.modifier(c.id, { police: police.getAttribute("data-police") })
        .then(function () { majPanneau(visuel()); });
      var couleur = e.target.closest("[data-couleur]");
      if (couleur) return void canevas.modifier(c.id, { couleur: couleur.getAttribute("data-couleur") })
        .then(function () { majPanneau(visuel()); });
      var contour = e.target.closest("[data-contour]");
      if (contour) {
        var v = contour.getAttribute("data-contour");
        return void canevas.modifier(c.id, { contour: v || null, contourEp: v ? 0.06 : 0 })
          .then(function () { majPanneau(visuel()); });
      }
      var fond = e.target.closest("[data-cv-fond]");
      if (fond) return void changerFond(c, fond.getAttribute("data-cv-fond") === "detoure");
      var action = e.target.closest("[data-cv-action]");
      if (!action) return;
      var quoi = action.getAttribute("data-cv-action");
      if (quoi === "supprimer") canevas.supprimer(c.id);
      else if (quoi === "dupliquer") canevas.dupliquer(c.id);
      else if (quoi === "avancer") canevas.avancer(c.id);
      else if (quoi === "reculer") canevas.reculer(c.id);
    });
  }

  $$("[data-sticker-opt]").forEach(function (grp) {
    var cle = grp.getAttribute("data-sticker-opt");
    grp.addEventListener("click", function (e) {
      var b = e.target.closest("[data-value]");
      if (!b || b.hidden) return;
      var v = b.getAttribute("data-value");
      // Le support ne touche ni au fichier ni au prix : il ne redemande donc ni cadrage ni
      // mesure. Le passage par le tronc commun relancerait une analyse de pixels pour une
      // simple mise à l'échelle du plan.
      if (cle === "support") {
        etat.support = v;
        majPills();
        majSupport();
        return;
      }
      if (cle === "lam") etat.lamination = v === "1";
      else if (cle === "taille" || cle === "qte") etat[cle] = parseInt(v, 10);
      else etat[cle] = v;

      // Une ellipse inscrite dans un carré serait un rond : on force une proportion
      // qui donne réellement un ovale.
      if (cle === "forme" && v === "ovale" && etat.proportion === "1:1") etat.proportion = "4:3";

      /*
       * ⛔ L'HOLOGRAPHIQUE PART SANS PELLICULE, ET L'ÉTAT DOIT LE DIRE. Cacher la rangée sans
       * remettre `lamination` à faux laisserait une lamination invisible dans le panier : le
       * client paierait le coefficient ×1,2 d'une option qu'il ne peut plus voir ni décocher,
       * et l'atelier collerait une pellicule sur un film qui n'en veut pas.
       */
      if (cle === "papier" && v === "holo") etat.lamination = false;

      /*
       * ⛔ SEULES LA DÉCOUPE ET LA PROPORTION TOUCHENT À LA GÉOMÉTRIE. Le format, la quantité,
       * le papier et la lamination laissent le dessin exactement où il est — et recalculer
       * pour rien faisait CLIGNOTER l'aperçu. Reproche de Jonathan le 20/08/2026 : « quand je
       * change de taille, y'a un recalcul du contour qui rend le switch pas agréable à voir ».
       * Le liseré et le papier sont des images masquées : chaque mesure les décroche, puis le
       * navigateur redécode une image identique, et le sticker disparaît le temps du trajet.
       *
       * ⛔ CE N'EST PAS UNE OPTIMISATION, C'EST UNE IDENTITÉ, et c'est ce qui la rend sûre. La
       * mesure reçoit `contourCm() / utile`, soit LISERE_RELATIF / (1 - 2 × LISERE_RELATIF) :
       * le format s'y simplifie. Le cadrage de même — il ne retient du format que le rapport
       * `contourCm() / etat.taille`, constant. Refaire le calcul rendrait donc le même liseré
       * au pixel près. `tests/sticker-matiere.test.js` le joue aux deux bouts de la gamme.
       *
       * ⚠️ SAUF SI LA SILHOUETTE N'EST PAS ENCORE CONNUE. Le papier d'une découpe à la forme
       * n'est peint qu'une fois le masque mesuré : sans cette réserve, un premier clic sur une
       * taille avant la fin de la mesure aurait laissé l'aperçu nu jusqu'au geste suivant.
       */
      var geometrie = cle === "forme" || cle === "proportion";
      if (geometrie || (etat.forme === "forme" && !masqueCourant)) {
        canevas.proportion(ratioCadre());
        // Sans ce recadrage, passer d'un rond à une découpe à la forme garderait un visuel
        // étalé en couverture, débordant d'une silhouette qui ne le rogne plus.
        cadrer(visuel());
        planifierMesure();
      }
      maj();
    });
  });

  var btn = $("[data-sticker-add]");
  if (btn) btn.addEventListener("click", ajouterAuPanier);

  /*
   * La barre d'achat collée du téléphone.
   *
   * ⛔ ELLE NE SORT PAS « QUAND LE BOUTON EST PASSÉ AU-DESSUS », comme sur la fiche affiche, et
   * cette règle-là ne marchait tout simplement pas ici. Mesure du 23/08/2026 en 375 × 667 :
   * « Ajouter au panier » est à 1 673 px, la page en fait 2 098, la fenêtre 667 — le défilement
   * s'arrête à 1 431 px et le bouton NE SORT JAMAIS par le haut. La barre copiée de l'affiche
   * ne s'est affichée à aucun moment du relevé. La fiche affiche a mille pixels de description
   * et d'avis sous son bouton ; cette fiche-là s'arrête juste après.
   *
   * La condition juste est donc l'inverse, et c'est celle d'un configurateur : la barre sort
   * dès que LE GESTE ATTENDU n'est plus à l'écran, qu'il soit passé au-dessus ou encore en
   * dessous. Choisir six rangées d'options avec le bouton d'achat trois écrans plus bas est le
   * cas ordinaire, pas l'exception.
   *
   * ⚠️ ET LE GESTE ATTENDU CHANGE : sans visuel, c'est le bouton d'import ; avec, le bouton
   * d'achat. La barre porte le même geste que son ancre, sans quoi elle proposerait de mettre
   * au panier un sticker qui n'existe pas.
   */
  (function () {
    var barre = $("[data-sticker-barre]");
    if (!barre || !btn) return;
    if (window.getComputedStyle(barre).display === "none") return;
    var relais = $("[data-sticker-barre-add]");
    var depot = $("[data-sticker-drop]");
    /* ⛔ RIEN DE TOUT CECI SUR ORDINATEUR. base.css efface déjà la barre au-dessus de 900 px,
       mais le calcul, lui, continuerait de tourner : il poserait `pdp-sticky-on` sur le corps
       de page et `--pdp-sticky-h` à zéro, ce qui déplace la bulle de chat pour une barre que
       personne ne voit. La colonne d'achat y est visible en permanence, de toute façon. */
    var telephone = window.matchMedia ? window.matchMedia("(max-width:900px)") : null;

    if (relais) {
      relais.addEventListener("click", function () {
        if (!canevas.vide()) return void btn.click();
        /* Rien à mettre au panier : la barre ouvre le sélecteur de fichiers là où le pouce
           se trouve. Le renvoyer vers le bouton d'import lui coûterait deux écrans de
           remontée pour le même geste. */
        var champ = $("[data-sticker-file]");
        if (champ) champ.click();
      });
    }

    function hauteur() {
      var on = document.body.classList.contains("pdp-sticky-on");
      var h = on ? Math.ceil(barre.getBoundingClientRect().height || 0) : 0;
      document.documentElement.style.setProperty("--pdp-sticky-h", h + "px");
    }

    function montrer(oui) {
      if (oui) {
        barre.hidden = false;
        document.body.classList.add("pdp-sticky-on");
        window.requestAnimationFrame(function () {
          barre.classList.add("show");
          hauteur();
        });
        return;
      }
      barre.classList.remove("show");
      document.body.classList.remove("pdp-sticky-on");
      hauteur();
    }

    /**
     * L'ancre est-elle sous les yeux ?
     *
     * ⛔ LA FENÊTRE N'EST PAS LA VUE. Deux bandes la mangent : l'aperçu épinglé en haut, et la
     * barre elle-même en bas. Un bouton d'achat glissé DERRIÈRE la barre passait pour visible,
     * la barre se retirait, le bouton reparaissait derrière elle — un clignotement à chaque
     * pixel de défilement. Les retirer de la vue donne l'hystérésis dans le bon sens : ce que
     * la barre cache reste caché tant qu'elle est là.
     */
    function souslesYeux(el) {
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) return false;
      var haut = 0;
      var plan = $("[data-cv-plan]");
      if (plan) {
        var rp = plan.getBoundingClientRect();
        // Sur téléphone, la configuration défile DERRIÈRE l'aperçu : son bas est le haut de la vue.
        if (rp.height) haut = Math.max(0, rp.bottom);
      }
      var bas = window.innerHeight || document.documentElement.clientHeight || 0;
      if (barre.classList.contains("show")) bas -= barre.getBoundingClientRect().height || 0;
      // Huit pixels de garde de chaque côté : un bouton à demi visible ne se clique pas au pouce.
      return r.bottom > haut + 8 && r.top < bas - 8;
    }

    function juger() {
      if (telephone && !telephone.matches) return void montrer(false);
      var ancre = canevas.vide() && depot ? depot : btn;
      montrer(!souslesYeux(ancre));
      if (document.body.classList.contains("pdp-sticky-on")) hauteur();
    }

    if ("IntersectionObserver" in window) {
      var oeil = new IntersectionObserver(juger, { threshold: [0, 0.01, 1] });
      oeil.observe(btn);
      if (depot) oeil.observe(depot);
    }
    window.addEventListener("scroll", juger, { passive: true });
    window.addEventListener("resize", juger, { passive: true });
    if (telephone && telephone.addEventListener) telephone.addEventListener("change", juger);
    jugerBarre = juger;
    juger();
  })();

  /*
   * ⚠️ TEMPORAIRE — ESSAYER LE FICHIER DE PRODUCTION SANS PASSER COMMANDE.
   *
   * Demande de Jonathan le 21/08/2026 : voir l'EPS que l'atelier recevra, sans payer cent
   * exemplaires pour le juger. Le bouton n'apparaît QUE si l'adresse porte `?eps=1` — c'est ce
   * qu'il a choisi contre un bouton toujours visible, et pour deux raisons : un client tombé sur
   * « fichier de production » téléchargerait un PostScript qu'il ne sait pas ouvrir et croirait
   * sa commande faite, et un fichier d'impression offert à qui passe rend le rendu gratuit.
   *
   * ⚠️ CE N'EST PAS UNE PORTE DÉROBÉE, et il faut le dire : `/sticker/document` est déjà
   * PUBLIQUE, sans session, parce que l'éditeur s'en sert avant tout compte — le paramètre ne
   * déverrouille donc rien, il ne fait qu'afficher un bouton. Ce qui protège le service est
   * ailleurs : origine autorisée et plafond horaire (`public-guard`).
   *
   * ⛔ RIEN ICI NE PASSE PAR LES TREIZE LANGUES, à dessein : ce bouton est un outil d'essai, il
   * doit disparaître sans laisser de clés orphelines dans les fichiers de langue. S'il devait
   * rester, c'est par là qu'il faudrait commencer.
   */
  if (/[?&]eps=1(?:&|$)/.test(window.location.search)) {
    var achat = btn && btn.parentNode;
    if (achat) {
      var boite = document.createElement("div");
      boite.className = "sticker__achat";
      boite.style.marginTop = "8px";
      var essai = document.createElement("button");
      essai.type = "button";
      essai.className = "btn sticker__add";
      essai.setAttribute("data-sticker-eps", "");
      essai.textContent = "⬇ Fichier de production (EPS)";
      boite.appendChild(essai);
      achat.parentNode.insertBefore(boite, achat.nextSibling);

      essai.addEventListener("click", function () {
        if (enCours || canevas.vide()) return;
        verrou(true);
        statut("Préparation du fichier de production…", "info");
        fabriquerFichier()
          .then(function (rendu) {
            /* Le serveur sert l'EPS en pièce jointe : suivre l'adresse suffit à l'enregistrer et
               la page reste en place. Un attribut `download` serait ignoré, l'adresse n'étant pas
               du domaine de la boutique. */
            window.location.href = rendu.url;
            var d = dimensionsCm();
            verrou(false);
            statut("Fichier prêt : " + d.l + " × " + d.h + " cm, découpe en CutContour2.", "info");
          })
          .catch(function (e) {
            verrou(false);
            var m = String((e && e.message) || e);
            if (window.console && console.error) console.error("sticker : EPS d'essai —", m, e);
            statut("Fichier de production indisponible : " + m, "erreur");
          });
      });
    }
  }

  // Un cran de zoom. Assez large pour qu'un clic se voie, assez fin pour ajuster sans
  // dépasser : douze pas suffisent à passer du quart au plein cadre.
  var PAS_ZOOM = 1.12;

  $$("[data-cv-zoom]").forEach(function (b) {
    b.addEventListener("click", function () {
      var c = canevas.selection();
      if (!c) return;
      var sens = Number(b.getAttribute("data-cv-zoom"));
      canevas.zoomer(c.id, sens > 0 ? PAS_ZOOM : 1 / PAS_ZOOM);
      majZoom(canevas.selection());
    });
  });

  /** Affiche la part du format occupée par le calque, et éteint les crans en butée. */
  function majZoom(calque) {
    var valeur = $("[data-cv-zoom-valeur]");
    var part = (calque && canevas) ? canevas.echelle(calque.id) : null;
    if (valeur) valeur.textContent = part ? Math.round(part * 100) + " %" : "—";
    $$("[data-cv-zoom]").forEach(function (b) {
      b.disabled = !calque;
    });
  }

  $$("[data-cv-histo]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (b.getAttribute("data-cv-histo") === "annuler") canevas.annuler();
      else canevas.refaire();
      majHistorique();
    });
  });

  /* --- Relief -------------------------------------------------------------------
   *
   * Un papier holographique ne se juge pas à plat : c'est en tournant qu'on voit le
   * spectre glisser, et c'est cette question-là que le client se pose avant de payer
   * un vinyle plus cher. Le relief incline donc le sticker et fait courir la lumière
   * dessus.
   *
   * C'est un temps d'arrêt, pas un mode d'édition. Le voile et ses cotes sont placés en
   * pixels mesurés sur le plan, et une scène tournée dans l'espace ne se mesure plus
   * ainsi : plutôt que de recalculer une géométrie fausse, on retire ces repères
   * d'atelier le temps du coup d'oeil.
   *
   * Rien n'est animé en JavaScript sinon deux angles et une teinte, posés en variables
   * CSS. Le navigateur n'a ni tracé ni mise en page à refaire, et le reflet suit le
   * doigt sans saccade — là où redessiner la matière à chaque frame coûterait une
   * analyse de pixels par mouvement.
   */
  var relief = false;
  var suitLaMain = false;
  var berceuse = null;

  // Quatorze degrés : assez pour que le spectre se déplace franchement, trop peu pour
  // que le sticker se lise de travers. Au-delà, la perspective écrase le dessin et on
  // ne juge plus la matière mais la déformation.
  var MAX_INCLINAISON = 14;

  var mouvementRefuse = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;

  /**
   * Incline le sticker et place la lumière, d'après un point du plan en fractions.
   *
   * Le reflet se pose LÀ où est la main : la main tient la lampe. Le sticker, lui, se
   * tourne vers elle. Les deux ensemble donnent le geste qu'on fait naturellement avec
   * un autocollant devant une fenêtre.
   */
  function poserLumiere(u, v) {
    var plan = $("[data-cv-plan]");
    if (!plan) return;
    var ry = (u - 0.5) * 2 * MAX_INCLINAISON;
    var rx = -(v - 0.5) * 2 * MAX_INCLINAISON;
    plan.style.setProperty("--cv-rx", rx.toFixed(2) + "deg");
    plan.style.setProperty("--cv-ry", ry.toFixed(2) + "deg");
    plan.style.setProperty("--cv-lx", (u * 100).toFixed(1) + "%");
    plan.style.setProperty("--cv-ly", (v * 100).toFixed(1) + "%");
    // La teinte tourne avec l'angle. C'est ce décalage du spectre qui sépare un vinyle
    // holographique d'un dégradé de couleurs imprimé : sur le second, incliner ne
    // change rien.
    plan.style.setProperty("--cv-hue", (ry * 4.6).toFixed(1) + "deg");
  }

  /**
   * Le balancement au repos : le sticker bouge de lui-même quand la main l'a lâché.
   *
   * Deux périodes sans rapport simple, pour que le mouvement ne repasse pas par le même
   * point et ne se lise pas comme une boucle.
   */
  function bercer(t) {
    if (!relief || suitLaMain) { berceuse = null; return; }
    var s = t / 1000;
    poserLumiere(0.5 + 0.30 * Math.sin(s * 0.62), 0.5 + 0.20 * Math.sin(s * 0.41 + 1.2));
    berceuse = window.requestAnimationFrame(bercer);
  }

  function bercerSiPermis() {
    // Mouvement refusé : le sticker ne bouge plus tout seul. La matière et le reflet
    // restent, le client les commande à la main.
    if (berceuse || !relief || (mouvementRefuse && mouvementRefuse.matches)) return;
    berceuse = window.requestAnimationFrame(bercer);
  }

  function arreterBerceuse() {
    if (berceuse) window.cancelAnimationFrame(berceuse);
    berceuse = null;
  }

  /*
   * ⚠️ LE BOUTON N'EST PLUS EXIGÉ. Il a quitté le balisage puisque le relief ne se
   * commande plus, et le réclamer ici sortait de la fonction sans rien incliner : le plan
   * restait à plat, sans matière, et rien ne le disait.
   */
  function basculerRelief(on) {
    var plan = $("[data-cv-plan]");
    if (!plan) return;
    relief = on;
    plan.setAttribute("data-relief", on ? "true" : "false");
    var b = $("[data-cv-relief]");
    if (b) b.setAttribute("aria-pressed", on ? "true" : "false");
    var t = $("[data-cv-relief-texte]");
    if (t) {
      t.textContent = on
        ? T("relief_quitter", "Revenir à la composition")
        : T("relief_voir", "Voir la matière");
    }
    if (on) return void bercerSiPermis();

    arreterBerceuse();
    suitLaMain = false;
    plan.removeAttribute("data-suit");
    // Retour à plat : rendre les angles suffit, la transition CSS fait le trajet.
    poserLumiere(0.5, 0.5);
    majVoile();
  }

  var planRelief = $("[data-cv-plan]");
  if (planRelief) {
    planRelief.addEventListener("pointermove", function (e) {
      if (!relief) return;
      var r = planRelief.getBoundingClientRect();
      if (!r.width || !r.height) return;
      suitLaMain = true;
      // Le suivi coupe la transition : sinon le reflet traîne derrière la main.
      planRelief.setAttribute("data-suit", "true");
      arreterBerceuse();
      var u = (e.clientX - r.left) / r.width;
      var v = (e.clientY - r.top) / r.height;
      poserLumiere(Math.min(1, Math.max(0, u)), Math.min(1, Math.max(0, v)));
    });

    planRelief.addEventListener("pointerleave", function () {
      if (!relief) return;
      suitLaMain = false;
      planRelief.removeAttribute("data-suit");
      if (mouvementRefuse && mouvementRefuse.matches) return void poserLumiere(0.5, 0.5);
      bercerSiPermis();
    });
  }

  var boutonRelief = $("[data-cv-relief]");
  if (boutonRelief) {
    boutonRelief.addEventListener("click", function () { basculerRelief(!relief); });
  }

  /*
   * Clavier de l'éditeur.
   *
   * Cmd/Ctrl+Z annule, avec Maj ou Ctrl+Y pour refaire. Tout est ignoré pendant une
   * saisie : le navigateur sait déjà annuler la frappe dans un champ.
   *
   * ⚠️ NI ÉCHAP NI SUPPR. Échap sortait du relief, qui ne se quitte plus. Suppr effaçait
   * le calque choisi, et le visuel l'est d'office à son arrivée : une frappe distraite
   * emportait donc le dessin, sans corbeille à l'écran pour le dire ni bouton pour le
   * rendre. On remplace un visuel en déposant le suivant, on ne le vide pas.
   */
  document.addEventListener("keydown", function (e) {
    var cible = e.target;
    if (cible && /^(INPUT|TEXTAREA|SELECT)$/.test(cible.tagName)) return;

    var meta = e.metaKey || e.ctrlKey;
    if (meta && (e.key === "z" || e.key === "Z")) {
      e.preventDefault();
      if (e.shiftKey) canevas.refaire(); else canevas.annuler();
      return void majHistorique();
    }
    if (meta && (e.key === "y" || e.key === "Y")) {
      e.preventDefault();
      canevas.refaire();
      return void majHistorique();
    }
  });

  // Le voile se dessine en pixels : il doit être refait quand la scène change de
  // taille, à la rotation d'un téléphone comme au repli d'une colonne.
  window.addEventListener("resize", majVoile);

  // Le service de détourage peut être éteint. Cela ne retire plus la découpe à la
  // forme, qui sait désormais suivre le bord d'un visuel gardé avec son fond : seul le
  // bouton « détourer » du calque devient inopérant, et il le montre.
  if (API) {
    fetch(API + "/sticker/health")
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.detourage !== "ok") {
          detourageEteint = true;
          majPanneau(visuel());
        }
      })
      .catch(function () { /* l'appel au dépôt dira la vérité */ });
  }

  monterPolices();
  monterCouleurs();
  canevas.proportion(ratioCadre());
  majHistorique();
  verrou(false);
  maj();
})();
